import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/flags/united-states.svg")